import React, { useEffect } from 'react';
import styles from './settings.module.scss';
import { FocusContext, setFocus, useFocusable } from '@noriginmedia/norigin-spatial-navigation';
import { useLocation, useNavigate } from 'react-router-dom';
import SettingsMenu from './settings-menu';
import { SETTINGS_CHANNELLIST_TAB_FOCUS_KEY } from './settings-menu';
import SettingsContent from './settings-content';
import { useSetAtom } from 'jotai';
import { topLevelPageReadyAtom } from '@smart-tv/atoms';

export enum tabs {
  CHANNELLIST,
  TECHNICAL,
  OPEN_SOURCE,
  GDPR
}

export const Settings: React.FC = () => {
  const [selectedTab, setSelectedTab] = React.useState<tabs | undefined>();
  const setTopLevelPageReady = useSetAtom(topLevelPageReadyAtom);
  const location = useLocation();
  const navigate = useNavigate();

  const { ref, focusKey } = useFocusable({
    preferredChildFocusKey: SETTINGS_CHANNELLIST_TAB_FOCUS_KEY,
    saveLastFocusedChild: false
  });

  useEffect(() => {
    setTopLevelPageReady(true);
  }, [setTopLevelPageReady]);

  useEffect(() => {
    if (location.state?.focusFirst !== true) return;

    setFocus(SETTINGS_CHANNELLIST_TAB_FOCUS_KEY);
    navigate(location.pathname, { replace: true, state: null });
  }, [location.pathname, location.state, navigate]);

  return (
    <FocusContext.Provider value={focusKey}>
      <div ref={ref} className={styles['settings']}>
        <SettingsMenu handleEnterPress={setSelectedTab} selectedTab={selectedTab} />
        <SettingsContent selectedTab={selectedTab} />
      </div>
    </FocusContext.Provider>
  );
};
export default Settings;
